// const BASE_URL = "http://localhost:5022/game-api/";
const BASE_URL = "https://pluto.passionit.com/game-api/game-api/";

export const LOGIN_API = `${BASE_URL}login`;
export const REGISTER_API = `${BASE_URL}register`;
export const GET_EMAIL_API = (email) => `${BASE_URL}get/regbyemail/${email}`;
export const PUT_REGISTER_API = (regid) => `${BASE_URL}reg/edit/${regid}`; 

///////////////////protectedroot///////////
export const GET_PROTECTED_API = `${BASE_URL}protected`;

/////////reset_forgot password//////////////
export const RESET_PASSWORD_API = `${BASE_URL}reset-password`
export const VALIDATE_TOKEN_API = `${BASE_URL}validate-reset-token`
export const UPDATE_PASSWORD_API = `${BASE_URL}password`
export const VERIFY_OTP_API = `${BASE_URL}verify-otp`

///////////////card group///////////////////
export const GET_CARDGROUP_API = `${BASE_URL}get/cardgroups`
export const POST_CARDGROUP_API = `${BASE_URL}post/cardgroups`
export const DELETE_CARDGROUP_API = (cardgrpid) => `${BASE_URL}delete/cardgroups/${cardgrpid}`; 
export const PUT_CARDGROUP_API = (cardgrpid) => `${BASE_URL}update/cardgroups/${cardgrpid}`; 
export const GET_CARDGROUP_BYID = (cardgrpid) => `${BASE_URL}get/cardgroups/${cardgrpid}`; 

////////////card/////////////////////
export const GET_CARD_API = `${BASE_URL}get/cards`
export const POST_CARD_API = `${BASE_URL}post/cards`
export const DELETE_CARD_API =(cardid)=> `${BASE_URL}delete/cards/${cardid}`
export const PUT_CARD_API = (cardid) => `${BASE_URL}update/cards/${cardid}`;
export const GET_CARD_BYID = (cardid) => `${BASE_URL}get/cards/${cardid}`;

////////////game category//////////////
export const GET_CATEGORY_API = `${BASE_URL}get/gamecategories`
export const POST_CATEGORY_API = `${BASE_URL}post/gamecategories`
export const DELETE_CATEGORY_API = (gamecategoryid) => `${BASE_URL}delete/gamecategories/${gamecategoryid}`;
export const PUT_CATEGORY_API = (gamecategoryid) => `${BASE_URL}update/gamecategories/${gamecategoryid}`;
export const GET_CATEGORY_BYID = (gamecategoryid) => `${BASE_URL}get/category/${gamecategoryid}`;

////////////group master//////////////////
export const GET_MASTER_API = `${BASE_URL}get/gamemasters`
export const POST_MASTER_API = `${BASE_URL}post/gamemasters`
export const DELETE_MASTER_API =(gamemasterid)=> `${BASE_URL}delete/gamemasters/${gamemasterid}`
export const PUT_MASTER_API = (gamemasterid) => `${BASE_URL}update/gamemasters/${gamemasterid}`;
export const GET_MASTER_BYID = (gamemasterid) => `${BASE_URL}get/master/${gamemasterid}`; 

/////////////card allocation//////////////
export const GET_ALLOCATION_API = `${BASE_URL}get/gamecardallocs`
export const POST_ALLOCATION_API = `${BASE_URL}post/gamecardallocs`
export const DELETE_ALLOCATION_API =(cardallocid)=> `${BASE_URL}delete/gamecardallocs/${cardallocid}`
export const PUT_ALLOCATION_API = (cardallocid) => `${BASE_URL}update/gamecardallocs/${cardallocid}`;
export const GET_ALLOCATION_BYID = (cardallocid) => `${BASE_URL}get/allocation/${cardallocid}`;
export const UPLOAD_ALLOCATION_API = `${BASE_URL}upload/gamecardallocs`;
export const FETCH_DATA_API = `${BASE_URL}get/fetchcategory`;
export const GET_GAME_CATEGORIES_API = `${BASE_URL}get/gamecategoriesforgame`;
export const GET_GAME_NAMES_API = `${BASE_URL}get/gamenames`;
export const GET_CARD_GROUPS_API = `${BASE_URL}get/cardgroups`;
export const GET_CARD_NAMES_API = `${BASE_URL}get/cardnames`;

//////////////Game PLay DB///////////////
export const GET_PLAY_API = `${BASE_URL}get/playdb`
export const POST_PLAY_API = `${BASE_URL}post/playdb`
export const DELETE_PLAY_API =(playid)=> `${BASE_URL}delete/playdb/${playid}`
export const PUT_PLAY_API = (playid) => `${BASE_URL}update/playdb/${playid}`;
export const GET_PLAY_BYID = (playid) => `${BASE_URL}get/play/${playid}`; 
export const GET_HISTORY_API= `${BASE_URL}get/history`;

///////////////Network////////////////
export const GET_NETWORK_API = `${BASE_URL}get/network`
export const POST_NETWORK_API = `${BASE_URL}post/network`
export const DELETE_NETWORK_API =(netid)=> `${BASE_URL}delete/network/${netid}`
export const PUT_NETWORK_API = (netid) => `${BASE_URL}update/network/${netid}`;
export const GET_NETWORK_BYID = (netid) => `${BASE_URL}get/network/${netid}`;



